import React from 'react'
import { Box } from '@shared/components/box'
import { Video } from '@shared/components/video'
import cn from 'classnames'
import { Article } from 'screens/about/sections/long-history/article'
import { videos } from 'screens/about/sections/long-history/tabs/2024/data'
import { VideoGrid } from 'screens/about/sections/long-history/video-grid'

import styles from './styles.module.scss'

export const View: React.FC = () => {
	return (
		<Article>
			<div className={styles.section}>
				<div>
					<p>
						Из года в год мы стремимся сделать клиентский путь ещё удобнее, чтобы приблизиться
						к одной из наших главных стратегический целей: упрощать доступ клиентам к финансовым
						услугам.
						<br />
						В 2024 году мы реализовали ряд улучшений:
					</p>
					<ol>
						<li>
							Обновили личные кабинеты клиентов и партнёров, чтобы оформление и пользование
							финансовыми продуктами было ещё комфортнее. Для тех же целей добавили новый функционал
							в приложение «Credit.Club Деньги».
						</li>
						<li>Усилили команду новыми специалистами: за год мы выросли на 40%.</li>
						<li>
							Внутри инвестиционного направления упростили процедуру верификации клиента: отменили
							селфи с паспортом и видеозвонок.
						</li>
					</ol>
				</div>
			</div>
			<h3>Масштабировали кредитное направление</h3>
			<div className={styles.section}>
				<div>
					В 2023 году в нашей аналитической статье мы прогнозировали увеличения спроса кредитования
					под залог недвижимости, а уже в следующем году наш прогноз подтвердился как минимум
					по показателям нашей команды. 2024 год стал для нас рекордным по кредитованию под залог
					недвижимости: размер кредитного портфеля увеличился за год на 366%.
				</div>
				<div className={styles.numberStats}>
					<div className={styles.bigNumber}>+ 336%</div>
					<div>Увеличение кредитного портфеля за год</div>
				</div>
			</div>
			<div className={styles.section}>
				<div>
					<h3>Вывели инвестиционное направление на новый уровень</h3>
					В 2024 году мы продолжили работу с разными площадками, агрегаторами и крупнейшими
					блогерами, чтобы о нашем инвестиционном продукте узнало ещё больше людей. Покажем
					небольшую часть активностей, которые помогли нам приблизиться к рекордным значениям:
				</div>
				<div>
					<div className={styles.numberStats}>
						<div className={styles.bigNumber}>+ 250%</div>
						<div>Рост портфеля Сбережений за год </div>
					</div>
					<div className={styles.numberStats}>
						<div className={styles.bigNumber}>+ 330%</div>
						<div>Увеличение количества активных сберегателей за год </div>
					</div>
				</div>
			</div>
			<VideoGrid videos={videos} />
			<div className={styles.section}>
				<div>
					<h3>Продолжили развивать платформу цифровых решений</h3>
					В 2024 году мы подключили к платформе ещё одну финансовую организацию и продолжили
					усиливать нашу экспертизу. В ходе совместной работы провели техническую интеграцию,
					учитывающую особенности IT-систем компаний. Также взяли на себя дополнительную
					ответственность, получив статус банковского платёжного агента.
				</div>
			</div>
			<div className={cn(styles.sectionColumns, styles.cards)}>
				<Box type='lightBlue'>
					<h4>Вошли в реестр малых технологических компаний Минэкономразвития России</h4>
					Инновационный центр «Сколково» провёл оценку наших технологий и принял решение включить
					Credit.Club в реестр малых технологических компаний Минэкономразвития России. Этот статус
					позволяет нам получать налоговые льготы в качестве поддержки со стороны государства.
				</Box>
				<Box type='lightBlue'>
					<h4>Продлили статус аккредитованной IT-компании на 2024 год</h4>
					Это значит, что мы можем продолжать пользоваться возможностями, которые даёт этот статус.
					Например, брать ипотеку с пониженной ставкой, а также рассчитывать на отсрочку от армии
					и мобилизации для IT-специалистов.
				</Box>
			</div>
			<div className={styles.sectionColumns}>
				<div>
					<h4>
						Поддержали инициативу Банка России и запустили совместный проект с АФГ «Процент» по
						защите людей от телефонного мошенничества
					</h4>
					<p>
						В рамках стратегического партнёрства по развитию финансовой грамотности в стране
						совместно с АФГ «Процент» мы помогаем людям уберечься от уловок аферистов и сохранить
						свои деньги.
					</p>
					<p>
						Наша работа по противодействию мошенничеству была отмечена Ежегодной национальной
						банковской премией. На этой премии уже почти двадцать лет выделяются проекты, которые
						делают финансовый рынок более прозрачным, безопасным и доступным.{' '}
					</p>
					<a
						href='https://percent.credit.club/protivostoim-telefonnym-moshennikam/'
						target='_blank' rel="noreferrer"
					>
						Узнать больше про наш проект →
					</a>
				</div>
				<div>
					<div className={styles.videoWrapper}>
						<Video
							src='https://public.credit.club/site/videos/afg-sad-girl.mp4'
							poster='/images/video-posters/scam.jpg'
							className={styles.video}
						/>
					</div>
				</div>
			</div>
		</Article>
	)
}
